export default function VersionChip({ version, behind, title }: { version: string | null | undefined; behind?: boolean; title?: string }) {
    if (!version) return <span className="version muted">—</span>;
    return (
        <span className={`version-chip ${behind ? "behind" : ""}`} title={title}>
            {version}
        </span>
    );
}
